import { Container } from "./TrainPage.styles";
import Train from "../../components/Train/Train";
import { useDispatch, useSelector } from "react-redux";
import { setSignUpModalOpen } from "../../store/slices/common/slice";
import { selectUser } from "../../store/slices/user/slice";

const TrainPage = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  return (
    <Container>
      <Train
        user={user}
        onLoginClick={() => {
          dispatch(setSignUpModalOpen(true));
        }}
      />
    </Container>
  );
};

export default TrainPage;
